export const roadMapElements = [
  {
    date: "March, 2020",
    iconName: "sitemap",
    title: "ES2020 Article",
    subtitle: "",
    description:
      "My first article got published on ASSIST Software's Blog page (click on this tab to take a look over it)",
    onclick: () => {
      const ES2020Url =
        "https://assist-software.net/snippets/top-new-features-ecmascript-2020-es2020";
      window.open(ES2020Url, "_blank").focus();
    },
  },
  {
    date: "July,2019",
    iconName: "university",
    title: "University",
    subtitle: "Ştefan cel Mare University of Suceava",
    description: "Economic Informatics",
  },
  {
    date: "July, 2019",
    iconName: "briefcase",
    title: "First Job",
    subtitle: "Suceava",
    description: "I got hired at ASSIST Software as a JavaScript Developer.",
  },
  {
    date: "May, 2018",
    iconName: "code",
    title: "First touch with Web dev.",
    subtitle: "",
    description: "Started learning Web bases, and creating projects",
  },
  {
    date: "September, 2016",
    iconName: "school",
    title: "High School",
    subtitle: "Suceava",
    description: "Mathematical Informatics ",
  },
  {
    date: "August, 2000",
    iconName: "baby",
    title: "Born",
    subtitle: "Suceava",
    description: "",
  },
];
